import { RadioBoxListItem } from "src/types/main";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import TGRadio from "./TGRadio";

export function TGRadioList({
  list,
  item,
  onChecked,
}: {
  list: RadioBoxListItem[];
  item: RadioBoxListItem | null;
  onChecked: (item: RadioBoxListItem) => void;
}) {
  function handleChecked(event: React.ChangeEvent<HTMLInputElement>) {
    const checked = list.find((l) => l.type === event.target.name);

    if (checked) onChecked(checked);
  }

  return (
    <FlexRow>
      <FlexCol
        className={twMerge(
          "gap-y-[15px] grow max-h-[350px] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-lg scrollbar-thumb-[#D1D5DB]"
        )}
      >
        {list.map((listItem, i) => {
          return (
            <TGRadio
              key={listItem.id}
              name={listItem.type}
              onChange={handleChecked}
              isChecked={!!item ? listItem.id === item.id : false}
              disable={false}
            >
              {listItem.title}
            </TGRadio>
          );
        })}
      </FlexCol>
    </FlexRow>
  );
}
